import { ref } from "vue";

/** Matches @vuepic/vue-datepicker weekStart prop (0 = Sunday … 6 = Saturday).
 * v11 has no WeekStart export.  Looks like v12 added one. */
export enum WeekStart {
  Sunday = 0,
  Monday = 1,
  Tuesday = 2,
  Wednesday = 3,
  Thursday = 4,
  Friday = 5,
  Saturday = 6,
}

/** Shared week-start for all VueDatePicker instances. Defaults to Sunday until user prefs load. */
export const vueDatePickerWeekStart = ref<WeekStart>(WeekStart.Sunday);

// Use this in the future if we want to make this configurable per user.
export function setVueDatePickerWeekStart(weekStart: WeekStart): void {
  vueDatePickerWeekStart.value = weekStart;
}
